import styled from "styled-components";
import { ButtonSize } from "./button-component.types";

export const StyledButton = styled.button<{
	$primary?: boolean;
	$size?: ButtonSize;
}>`
  background-color: ${({ $primary, theme }) => ($primary ? theme.colors.primary : "transparent")};
  padding: ${({ $size }) => ($size === "small" ? "0.5rem 1rem" : $size === "large" ? "1rem 2rem" : "0.75rem 1.5rem")};
  color: ${({ $primary, theme }) => ($primary ? "white" : theme.colors.primary)};
  height: ${({ $size }) => ($size === "small" ? "36px" : $size === "large" ? "56px" : "48px")};
  min-width: ${({ $size }) => ($size === "small" ? "72px" : $size === "large" ? "96px" : "84px")};
  border: ${({ $primary, theme }) => ($primary ? "none" : `2px solid ${theme.colors.primary}`)};
  outline: none;
  border-radius: 1.5rem;
  cursor: pointer;
  font-weight: bold;
  font-size: ${({ $size, theme }) =>
		$size === "small"
			? theme.typeScale.sm[100]
			: $size === "large"
				? theme.typeScale.lg[300]
				: theme.typeScale.lg[200]};
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  position: relative;
  overflow: hidden;

  span {
    background-image: ${({ $primary, theme }) => ($primary ? "none" : theme.colors.goldGradient)};
    background-clip: text;
    color: ${({ $primary }) => ($primary ? "white" : "transparent")};
    transition: all 0.2s ease;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ $primary }) => ($primary ? "0 4px 6px rgba(0, 0, 0, 0.1)" : "none")};

    span {
      background-image: ${({ theme }) => theme.colors.gold};
      background-clip: text;
color:transparent;
    }
  }

  &:active {
    transform: translateY(0);
    box-shadow: none;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(5, 0, 26, 0.3);
  }

  &:disabled {
    background-color: ${({ $primary }) => ($primary ? "#cccccc" : "transparent")};
    border-color: #cccccc;
    color: #666666;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;

    span {
      background-image: none;
      color: #666666;
    }
  }
`;
